import "./cache-page.css";
import '../../../css/app.css';
import React, {useCallback, useEffect, useRef, useState} from "react";
import MapComponent from './mapcomponent';
import withNavigation from "../higher-order/navigation";
import {connect} from "react-redux";
import {getConfigurationByKeyNames} from "../../server/services/configuration-service";
import SessionKeys from '../../session'
import {setAlert} from '../actions/alert';
import {apiKey} from "./googleApi";
import {APIProvider} from "@vis.gl/react-google-maps";
import {Round} from "../../utils/NumbersUtils";


const CachePage = (props) => {
    const [searchCoordinates, setSearchCoordinates] = useState({
        searchLat: 0,
        searchLatMin: 0,
        searchLatSec: 0,
        searchLatitude: "0",
        searchLon: 0,
        searchLonMin: 0,
        searchLonSec: 0,
        searchLongitude: "0",
    })
    const [coordinates, setCoordinates] = useState({
        minLat: 0,
        maxLat: 0,
        minLng: 0,
        maxLng: 0,
        center: {lat: 0, lng: 0}
    })
    const mapRef = useRef(null)

    useEffect(() => {
        getConfigurationByKeyNames(["LATITUDE_MINIMUM_CACHE", "LATITUDE_MAXIMUM_CACHE", "LONGITUDE_MINIMUM_CACHE", "LONGITUDE_MAXIMUM_CACHE", "DISTANCE_MINIMUM_CACHE"]).then((config) => {
            sessionStorage.setItem(SessionKeys.DISTANCE_MINIMUM_CACHE, config["DISTANCE_MINIMUM_CACHE"].replace(",", "."));
            const minLat = parseFloat(config["LATITUDE_MINIMUM_CACHE"].replace(",", "."));
            const maxLat = parseFloat(config["LATITUDE_MAXIMUM_CACHE"].replace(",", "."));
            const minLng = parseFloat(config["LONGITUDE_MINIMUM_CACHE"].replace(",", "."));
            const maxLng = parseFloat(config["LONGITUDE_MAXIMUM_CACHE"].replace(",", "."));

            setCoordinates({
                minLat,
                maxLat,
                minLng,
                maxLng,
                center: {
                    lat: (minLat + maxLat || 0) / 2, lng: ((minLng || 0) + maxLng || 0) / 2,
                }
            });
        })
    }, [])

    const recalculateCoordinates = () => {
        let degrees = searchCoordinates.searchLat
        let degreesAbs = Math.abs(Number(degrees))
        let minutes = searchCoordinates.searchLatMin;
        let seconds = searchCoordinates.searchLatSec;
        let latitude = degreesAbs + (Number(minutes) / 60) + (Number(seconds) / 3600);
        if (Number(degrees) !== degreesAbs) latitude = latitude * -1;
        degrees = searchCoordinates.searchLon;
        degreesAbs = Math.abs(Number(degrees))
        minutes = searchCoordinates.searchLonMin;
        seconds = searchCoordinates.searchLonSec;
        let longitude = degreesAbs + (Number(minutes) / 60) + (Number(seconds) / 3600);
        if (Number(degrees) !== degreesAbs) longitude = longitude * -1;

        setSearchCoordinates(prev => ({
            ...prev,
            searchLatitude: latitude, searchLongitude: longitude,
        }));
    }

    useEffect(() => {
        if (Number(searchCoordinates.searchLatitude) === 0 || Number(searchCoordinates.searchLongitude) === 0) return;
        mapRef.current.coordinateChanged(searchCoordinates.searchLatitude, searchCoordinates.searchLongitude);
    }, [searchCoordinates.searchLatitude, searchCoordinates.searchLongitude]);

    const handleCoordinateChange = useCallback((e, longueurFixed) => {
        const value = Number(e.target.value);
        setSearchCoordinates((prev) => ({...prev, [`search${ e.target.id }`]: value}))
    }, [])

    const newClickSurLaCarte = (lat, lng) => {

        let latAbs = Math.abs(lat);
        let lngAbs = Math.abs(lng);

        const latDeg = Math.floor(latAbs);
        const latOri = Math.trunc(lat);
        const lngDeg = Math.floor(lngAbs);
        const lngOri = Math.trunc(lng);

        const latMinFloat = (latAbs - latDeg) * 60;
        const lngMinFloat = (lngAbs - lngDeg) * 60;

        const latMin = Math.floor(latMinFloat);
        const lngMin = Math.floor(lngMinFloat);

        const latSecFloat = (latMinFloat - latMin) * 60;
        const lngSecFloat = (lngMinFloat - lngMin) * 60;

        const latSec = Math.floor(latSecFloat);
        const lngSec = Math.floor(lngSecFloat);

        setSearchCoordinates(prev => ({
            ...prev,
            searchLat: latOri, searchLatMin: latMin, searchLatSec: latSec, searchLon: lngOri, searchLonMin: lngMin, searchLonSec: lngSec, searchLatitude: lat, searchLongitude: lng,
        }));
    };

    return (<div className="cache-page">
        <div className="section ng-hide">
            <div className="col-xs-12 col-sm-12">
            </div>
        </div>

        <div className="reactive-table-container">
            { props.authToken != null ?
                <div className="votrecache">
                    <h1 className="secondary-color-1 center">Votre cache</h1>
                    <h4 className="secondary-color-1 bottom-separator"></h4>
                    <div className="col-sm-12 col-xs-12">
                        <table className="table table-bordered">
                            <tbody>
                            <tr>
                                <th className="secondary-color-1-darker ng-binding">No. cache</th>
                                <th className="secondary-color-1-darker ng-binding">Secteur</th>
                                <th className="secondary-color-1-darker ng-binding">Latitude</th>
                                <th className="secondary-color-1-darker ng-binding">Longitude</th>
                                <th className="secondary-color-1-darker ng-binding">Année</th>
                                <th className="secondary-color-1-darker ng-binding ng-hide">Renouveler</th>
                                <th className="secondary-color-1-darker ng-binding ng-hide">Déplacer</th>
                            </tr>
                            </tbody>
                        </table>
                        <span>Pour pouvoir renouveler votre cache, vous devez acheter votre forfait de chasse dans la section « Choisir un forfait ».</span>
                    </div>
                </div>
                :
                <h1 id="valider-deplacer-cache-title" className="secondary-color-1 center ng-binding">
                    Valider cache
                </h1>
            }

            <div className="col-sm-12 col-xs-12">
                <h4 className="col-sm-12 col-xs-12 secondary-color-1 bottom-separator ng-binding">Coordonnées</h4>
            </div>
            <div className="col-sm-12 col-xs-12">
                <table className="table table-bordered">
                    <tbody>
                    <tr>
                        <th className="secondary-color-1-darker"></th>
                        <th className="secondary-color-1-darker ng-binding">Degrés</th>
                        <th className="secondary-color-1-darker ng-binding">Minutes</th>
                        <th className="secondary-color-1-darker ng-binding">Secondes</th>
                        <th className="secondary-color-1-darker ng-binding">Degrés décimaux</th>
                    </tr>
                    <tr>
                        <th className="secondary-color-1-darker">Latitude</th>
                        <td><input id="Lat" value={ searchCoordinates.searchLat } onChange={ handleCoordinateChange } onBlur={ recalculateCoordinates }/></td>
                        <td><input id="LatMin" value={ searchCoordinates.searchLatMin } onChange={ handleCoordinateChange } onBlur={ recalculateCoordinates }/></td>
                        <td><input id="LatSec" value={ searchCoordinates.searchLatSec } onChange={ handleCoordinateChange } onBlur={ recalculateCoordinates }/></td>
                        <td><input id="Latitude" value={ searchCoordinates.searchLatitude } onChange={ (e) => handleCoordinateChange(e) } onBlur={ () => newClickSurLaCarte(searchCoordinates.searchLatitude, searchCoordinates.searchLongitude) }/></td>
                    </tr>
                    <tr>
                        <th className="secondary-color-1-darker">Longitude</th>
                        <td><input id="Lon" value={ searchCoordinates.searchLon } onChange={ handleCoordinateChange } onBlur={ recalculateCoordinates }/></td>
                        <td><input id="LonMin" value={ searchCoordinates.searchLonMin } onChange={ handleCoordinateChange } onBlur={ recalculateCoordinates }/></td>
                        <td><input id="LonSec" value={ searchCoordinates.searchLonSec } onChange={ handleCoordinateChange } onBlur={ recalculateCoordinates }/></td>
                        <td><input id="Longitude" value={ searchCoordinates.searchLongitude } onChange={ (e) => handleCoordinateChange(e) } onBlur={ () => newClickSurLaCarte(searchCoordinates.searchLatitude, searchCoordinates.searchLongitude) }/></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="col-xs-12 col-sm-12 pull-right">
                <div className="row">
                    <input type="hidden" id="postId" name="postId" value="34657"/>
                    <div className="col-sm-12 col-xs-12">
                        <button type="button" className="btn btn-positive btn-end-of-section float-right ng-binding" onClick={ e => mapRef.current.validateMarker(1) }>
                            Valider
                        </button>
                    </div>
                </div>
            </div>
            <h1 className="secondary-color-1 center ng-binding">Vos caches sur la carte</h1>
            <div className="CachePage">
                <APIProvider apiKey={ apiKey }>
                    <MapComponent ref={ mapRef } coordinatesZEC={ coordinates } newClickSurLaCarte={ newClickSurLaCarte }/>
                </APIProvider>
            </div>
        </div>
    </div>);
}

function mapStateToProps(state) {
    return {
        authToken: state.authToken, parametresWeb: state.parametresWeb, configuration: state.configuration, overlay: state.overlay, entrepriseName: state.entreprise.nom,
    };
}

export default withNavigation(connect(mapStateToProps, {setAlert})(CachePage));
